export const menuItems = [
  {
    title: "File",
    submenu: [
      {
        title: "New",
      },
      {
        title: "Save",
      },
      {
        title: "Download",
        submenu: [
          {
            title: "Microsoft Word (.docx)",
          },
          {
            title: "Plain Text (.txt)",
          }
        ],
      },
      {
        title: "Move to Trash",
      },
    ],
  },
  {
    title: "Edit",
    submenu: [
      {
        title: "Undo"
      },
      {
        title: "Redo"
      },
      {
        title: "Cut"
      },
      {
        title: "Copy"
      },
      {
        title: "Paste"
      },
      {
        title: "Delete",
      },
      {
        title: "Select All"
      }
    ]
  },
  {
    title: "View",
    submenu: [
      {
        title: "Full Screen",
      }
    ],
  },
  {
    title: "Insert",
    submenu: [
      {
        title: "Link"
      }
    ]
  },
  {
    title: "Format",
    submenu: [
      {
        title: "Capitalization",
        submenu: [
          {
            title: "lowercase",
          },
          {
            title: "UPPERCASE",
          },
          {
            title: "Title Case",
          },
        ]
      }
    ]
  },
  {
    title: "Tools",
    submenu: [
      {
        title: "Word Count",
      },
      {
        title: "Find and Place"
      },
      {
        title: "Spell Checker"
      }
    ]
  },
  {
    title: "Add-ons",
    submenu: [
      {
        title: "Named Entity (NER)",
      },
      {
        title: "Synonyms",
      },
      {
        title: "Paraphrase"
      }
    ],
  },
  {
    title: "Help",
    submenu: [
      {
        title: "Keyboard Shortcuts"
      }
    ]
  },
];
